export default __webpack_public_path__ + "static/media/SprintCentral.a8dfa6ded368f5fd0db7949c609e3c3d.webp";